import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";
import { DataTable } from "react-native-paper";

const MemberRowSkeletonCells = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity, flex: 1 }}>
      <View className="flex-row items-center flex-1 py-3">
        {/* Avatar + name */}
        <View className="flex-row items-center gap-2 flex-[2]">
          <View className="hidden sm:flex h-8 w-8 rounded-full bg-ash-3" />
          <View className="h-3 w-2/3 rounded-md bg-ash-3" />
        </View>
        {/* Email */}
        <View className="flex-[3]">
          <View className="h-3 w-3/4 rounded-md bg-ash-3" />
        </View>
        {/* Chip / role / action */}
        <View className="flex-1 items-start">
          <View className="h-5 w-16 rounded-full bg-ash-3" />
        </View>
      </View>
    </Animated.View>
  );
};

const MemberRowSkeleton = ({ count = 5 }: { count?: number }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <DataTable.Row key={index}>
        <DataTable.Cell style={{ flex: 1 }}>
          <MemberRowSkeletonCells />
        </DataTable.Cell>
      </DataTable.Row>
    ))}
  </>
);

export default MemberRowSkeleton;
